

import { Navigate, Outlet } from "react-router-dom";
import { selectData } from "../redux/features/userSliceWithTokenValidation";
import { useSelector } from "react-redux";

export const ROLES = "coach" | "bakeliste" | "stagiaire" | "coach-assistant" | "*";

function RequiredRole({ roles, children }) {
    const user = useSelector(selectData);
    
  return roles.includes(user?.statut) || roles.includes("*") ? (
    children ? (
      children
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to={"/"} replace />
  );
}

export default RequiredRole;